import { StoreDetails } from "@/data/types/Store";
export const fetchSpecialStoreTimings = (store:StoreDetails,storeClosed?:boolean) => {
    let storeTimings:string | undefined;
    const today = new Date();
    let date2 = today.toJSON().slice(0, 10);
    if(storeClosed){
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        date2 = tomorrow.toJSON().slice(0, 10);
    }
    const newDate = date2.slice(8, 10) + '-' 
               + date2.slice(5, 7) + '-' 
               + date2.slice(0, 4); 
    store?.attributes?.forEach((attrItem, j)=>{
        if(attrItem.name.startsWith("specialopen") && attrItem.value != "0" && attrItem.displayName.startsWith(newDate)){
            storeTimings = attrItem.displayValue;
       }
    })
    return storeTimings;
}

export const updateStoreDate = (newDate:string, date:Date) => {
    date.setHours(parseInt(newDate.substring(0,2)));
    date.setMinutes(parseInt(newDate.substring(2,4)));
    date.setSeconds(0,0);
    return date;
}

export function setCookie(cookieName:string, cookieVal:string, props?:Record<string,string|number|Date>) {
    var createCookie = function(name:string, value:string, props?:Record<string,string|number|Date>){
        if (!props) {
            props = {};
        }

        var exp = props.expires;
        if (exp) {
            if(typeof exp == "number"){
                var d = new Date();
                d.setTime(d.getTime() + exp*24*60*60*1000);
                exp = d;
            }
            if (typeof exp == "object" && exp.toUTCString){
                props.expires = exp.toUTCString();
            } else {
                props.expires = exp;
            }
        }

        value = encodeURIComponent(value);
        var propString = name + "=" + value;
        for(var name in props){
            propString += "; " + name;
            var propValue = props[name];
            if(propValue !== "true"){
                propString += "=" + propValue;
            }
        }
        document.cookie = propString;
    };

    if (!props) {
        createCookie(cookieName, cookieVal);
    } else {
        var cookieProps = props;
        for (var propName in cookieProps) {
            if (!cookieProps[propName]) {
                delete cookieProps[propName];
            }
        }
        createCookie(cookieName, cookieVal, cookieProps);
    }
}

export function getCookie(c:string) {
    if (typeof window === "undefined") return "";
    var cookies = window.document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("="),
        name = cookies[i].substr(0,index);
        name = name.replace(/^\s+|\s+$/g,"");
        if (name == c) {
            return decodeURIComponent(cookies[i].substr(index + 1));
        }
    }
}